module.exports = __webpack_public_path__ + "static/media/new_corporate.c8f58eeb.png";